import request from '@/utils/request'

// 新增 AMC 用户
export function amcUserAdd(data) {
  return request({
    url: '/amcusers',
    method: 'post',
    data
  })
}

// AMC 用户登录
export function amcLogin(data) {
  return request({
    url: '/amcusers/login',
    method: 'post',
    data
  })
}

// 根据 ID 删除 AMC 用户
export function amcUserDel(id) {
  return request({
    url: `/amcusers/${id}`,
    method: 'delete'
  })
}

// 批量删除 AMC 用户（JSON 数组主体）
export function amcUserBatchDel(ids) {
  return request({
    url: '/amcusers/batch',
    method: 'delete',
    data: ids
  })
}

// 更新 AMC 用户
export function amcUserUpdate(data) {
  return request({
    url: '/amcusers',
    method: 'put',
    data
  })
}

// 按用户名更新 AMC 用户（PUT /amcusers/by-username）
export function amcUserUpdateByUsername(data) {
  return request({
    url: '/amcusers/by-username',
    method: 'put',
    data
  })
}

// 根据 ID 查询 AMC 用户详情
export function amcUserDetail(id) {
  return request({
    url: `/amcusers/${id}`,
    method: 'get'
  })
}

// 根据用户名查询 AMC 用户
export function amcUserByUsername(username) {
  return request({
    url: '/amcusers/by-username',
    method: 'get',
    params: { username }
  })
}

// 查询所有 AMC 用户
export function amcUserListAll() {
  return request({
    url: '/amcusers/all',
    method: 'get'
  })
}

// 分页查询 AMC 用户（支持条件：username, realName, repoId, roleId）
export function amcUserPaging(params) {
  return request({
    url: '/amcusers/page',
    method: 'get',
    params
  })
}
